import { useContext, useEffect, useState } from "react";
import MainButton from "../MainButton/MainButton";
import "./style.css";
import React from "react";
import { popupContext } from "../../../contextAdmin/Admin/Popup";
import Input from "../../Common/Input/Input";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import classRequets from "../../api/classRequest";
import { userContext } from "../../../contextAdmin/Admin/User";

// Creator : Team E - Chanan
function EditClass(props) {
  const { setPopup } = useContext(popupContext);
  const { list, setList } = useContext(listControllerContext);
  const [newID, setNewID] = useState(props.classId);
  const { user, setUser } = useContext(userContext);
  const [newClassName, setNewClassName] = useState(props.classroomName)

  useEffect(() => {
    if (props.type == "New Classroom") {
      getNewClassId().then(res => {
        setNewID(res)
      })
    }
    if (props.type == "Edit class") {
      setNewClassName(props.classroomName)
    }
  }, [])


  function closePopup(e) {
    e.preventDefault();
    setPopup(false);
  }

  async function getNewClassId() {
    return await classRequets.getNewClassId()
  }

  async function onSubmit(e) {
    e.preventDefault();
    const updateClass = {
      classroomId: newID,
      classroomName: newClassName,
      teacherId: user.id
    };
    let classUpdated = await props.onSubmit(updateClass)
    let newClassList = await classRequets.getAllTeacherClasses(user.id)
    if (newClassList.length) {
      setList(prev => newClassList)
    } else {
      setList([
        {
          classroomName: "",
          classroomId: "",
          students: [],
        },
      ]);
    }

    setPopup(false);
  }

  function createnewID(e) {
    setNewID(e.target.value)
  }
  function handleClassName(e) {
    setNewClassName(e.target.value)
  }
  // useEffect(createnewID, []);

  return (
    <div>
      <form onSubmit={onSubmit}>
        {
          props.type == "Delete class" ?
            <div>are you sure you want to delete <b>{props.classroomName}</b>{" "}class? [id: {newID}]  </div>
            :
            <div>
              <Input legend={"Classroom name"} value={newClassName} name="className" onChange={handleClassName} valid={"yes"} />
              <Input disabled legend={"Classroom ID"} value={newID} onChange={createnewID} name="classID" valid={"yes"} />
            </div>
        }
        <div className="popup-fotter">
          <button className="btn" type="button" onClick={closePopup}>
            Cancel
          </button>
          <button type="submit" className="btn" disabled={!newClassName || !newID}>{props.type == "Edit class" ? "Edit" : props.type == "Delete class" ? "Delete" : "Add"}</button>
        </div>
      </form>
    </div>
  );
}
export default EditClass;
